<template lang="pug">
  router-view()
</template>

<script>

export default {
}
</script>

<style lang="scss">

::v-deep #full-screen-modal > .modal-dialog {
        max-height: 100%;
    }  

  .bg-warning {
    background-color: #f0ad4e !important;
  }

  .b-toast-primary {
  box-shadow: 0 0 0 5px hsl(207, 23%, 92%) !important;
  position: fixed;
  border-radius: 0px;
  width: 300px;
  right: 20px;
  top: 10px;
  .toast-header, .toast-body {
    background-color: #fff !important;
    font-size: 12px;
    color: #000;
  }
  background-color: #fff;
  padding: 10px;
}  
</style>
